<template>
  <div>
    <!-- New Cards Section -->
    <a-row :gutter="[24, 24]" style="margin-bottom: 24px" v-if="undefined">
      <a-col :span="6">
        <a-card
          :bodyStyle="{
            height: '120px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }"
          style="border-radius: 8px"
          :bordered="true"
        >
          <div style="font-weight: 600; font-size: 14px">
            Pending Allocations
          </div>
          <div
            style="
              font-size: 18px;
              font-weight: 700;
              color: #26a246;
              margin-top: 8px;
            "
          >
            {{ allocationStats.pendingAllocations || 0 }}
          </div>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card
          :bodyStyle="{
            height: '120px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }"
          style="border-radius: 8px"
          :bordered="true"
        >
          <div style="font-weight: 600; font-size: 14px">
            Total Quantity Allocated
          </div>
          <div
            style="
              font-size: 18px;
              font-weight: 700;
              color: #26a246;
              margin-top: 8px;
            "
          >
            {{ allocationStats.totalQuantityAllocated || 0 }}
            <span style="font-size: 14px; color: #888"> doses</span>
          </div>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card
          :bodyStyle="{
            height: '120px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }"
          style="border-radius: 8px"
          :bordered="true"
        >
          <div style="font-weight: 600; font-size: 14px">
            Avg. Fulfillment Time
          </div>
          <div
            style="
              font-size: 18px;
              font-weight: 700;
              color: #26a246;
              margin-top: 8px;
            "
          >
            {{ allocationStats.avgFulfillmentTime || 0 }}
            <span style="font-size: 14px; color: #888"> days</span>
          </div>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card
          :bodyStyle="{
            height: '120px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }"
          style="border-radius: 8px"
          :bordered="true"
        >
          <div style="font-weight: 600; font-size: 14px">
            Total Allocation Value
          </div>
          <div
            style="
              font-size: 18px;
              font-weight: 700;
              color: #26a246;
              margin-top: 8px;
            "
          >
            {{ formatAmount(allocationStats.totalAllocationValue) }}
          </div>
        </a-card>
      </a-col>
    </a-row>

    <!-- Search and Filter Section -->
    <a-row :gutter="[16, 16]" style="margin-bottom: 16px">
      <a-col :span="12">
        <p style="margin: 0px">Search</p>
        <a-input-search
          placeholder="Search by allocation ID"
          style="width: 100%"
          v-model="filters.search"
          :value="allocationSearchQuery"
        />
      </a-col>
      <a-col :span="6">
        <p style="margin: 0px">Status</p>
        <a-select
          defaultValue="All"
          style="width: 100%"
          v-model="filters.status"
        >
          <a-select-option
            v-for="option in statusOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </a-select-option>
        </a-select>
      </a-col>
      <!-- <a-col :span="6">
        <a-select
          defaultValue="all"
          style="width: 100%"
          @change="onAllocationDateFilterChange"
        >
          <a-select-option value="all">Filter by Date (All)</a-select-option>
          <a-select-option value="today">Today</a-select-option>
          <a-select-option value="week">This Week</a-select-option>
          <a-select-option value="month">This Month</a-select-option>
        </a-select>
      </a-col> -->
    </a-row>

    <EmptyState
      v-if="orderAllocations.length === 0 && !loadingAllocations"
      icon="fa-clipboard-list"
      title="No allocation requests found"
      description="Allocation requests will appear here when available."
      :hasActiveFilter="Object.values(filters).some(filter => filter)"
    />
    <a-table
      v-else
      :data-source="orderAllocations"
      :loading="loadingAllocations"
      rowKey="id"
      :pagination="{
        current: pagination.pageIndex,
        pageSize: pagination.pageSize,
        total: pagination.totalCount,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} allocations`,
        showSizeChanger: false
      }"
      :scroll="{ x: 'max-content' }"
      style="background: #fff; margin-top: 16px"
      @change="handleTableChange"
    >
      <a-table-column
        title="Request ID"
        dataIndex="allocationId"
        key="allocationId"
      />
      <a-table-column
        title="Consignment ID"
        dataIndex="consignmentId"
        key="consignmentId"
      />
      <a-table-column
        title="Distribution Center"
        dataIndex="distributionCenter"
        key="distributionCenter"
      />
      <a-table-column
        title="Stock Requested"
        dataIndex="totalStockRequested"
        key="totalStockRequested"
      />
      <a-table-column
        title="Status"
        key="status"
      >
        <template slot-scope="text, record">
          <StatusTag :status="record.status" />
        </template>
      </a-table-column>
      <a-table-column
        title="Submitted By"
        dataIndex="requestedBy"
        key="requestedBy"
      />
      <a-table-column
        title="Date"
        key="submissionDate"
        :customRender="(text, record) => formatDate(record.submissionDate)"
      />
      <a-table-column title="Actions" key="actions">
        <template slot-scope="text, record">
          <a-button type="link" @click="handleAllocationView(record)">
            <i class="fa fa-eye" style="color: #9e9e9e" aria-hidden="true"></i>
          </a-button>
        </template>
      </a-table-column>
    </a-table>
  </div>
</template>

<script>
import sellersService from "@/api/sellers.service";
import StatusTag from "../../shared-components/StatusTag.vue";
import { formatDate, formatAmount } from "../../../utils";
import EmptyState from "../../shared-components/EmptyState.vue";

export default {
  name: "SellerAllocationsTab",
  components: { StatusTag, EmptyState },
  props: {
    sellerId: { type: String, required: true },
  },
  data() {
    return {
      allocations: [],
      loadingAllocations: false,
      filters: {
        search: null,
        status: null,
      },
      searchDebounceTimer: null,
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0,
      },
      statusOptions: [
        { label: "All", value: null },
        { label: "Pending", value: "Pending" },
        { label: "Completed", value: "Completed" },
        { label: "Cancelled", value: "Cancelled" }
      ]
    };
  },
  computed: {
    orderAllocations() {
      return this.allocations;
    },
    allocationStats() {
      const pendingAllocations = this.allocations.filter(a => a.status?.toLowerCase() === 'pending').length;
      const totalQuantityAllocated = this.allocations.reduce((sum, a) => sum + (Number(a.totalStockRequested) || 0), 0);
      const avgFulfillmentTime = this.calculateAverageFulfillmentTime(this.allocations);
      const totalAllocationValue = this.allocations.reduce((sum, a) => sum + (Number(a.totalValue) || 0), 0);
      return {
        pendingAllocations,
        totalQuantityAllocated,
        avgFulfillmentTime,
        totalAllocationValue,
      };
    },
    columns() {
      return [
        { title: "Request ID", dataIndex: "allocationId", key: "allocationId" },
        {
          title: "Consignment ID",
          dataIndex: "consignmentId",
          key: "consignmentId",
        },
        {
          title: "Distribution Center",
          dataIndex: "distributionCenter",
          key: "distributionCenter",
        },
        {
          title: "Stock Requested",
          dataIndex: "totalStockRequested",
          key: "totalStockRequested",
        },
        {
          title: "Status",
          key: "status",
          scopedSlots: { customRender: "status" },
        },
        { title: "Submitted By", dataIndex: "requestedBy", key: "requestedBy" },
        {
          title: "Date",
          key: "createdAt",
          scopedSlots: { customRender: "date" },
        },
        {
          title: "Actions",
          key: "actions",
          scopedSlots: { customRender: "actions" },
        },
      ];
    },
    cardBodyStyle() {
      return {
        height: "120px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      };
    },
    tablePagination() {
      return {
        current: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
        total: this.pagination.totalCount,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} allocations`,
        showSizeChanger: false,
      };
    },
  },
  watch: {
    "filters.search"() {
      if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.pagination.pageIndex = 1;
        this.fetchAllocations();
      }, 400);
    },
    "filters.status"() {
      this.pagination.pageIndex = 1;
      this.fetchAllocations();
    },
    "pagination.pageIndex"() {
      this.fetchAllocations();
    },
    sellerId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.pagination.pageIndex = 1;
          this.fetchAllocations();
        }
      },
    },
  },
  methods: {
    formatDate,
    formatAmount,
    async fetchAllocations() {
      this.loadingAllocations = true;
      const response = await sellersService.fetchSellerAllocations(
        this.sellerId,
        {
          ...this.filters,
          pageIndex: this.pagination.pageIndex,
          pageSize: this.pagination.pageSize,
        }
      );
      console.log("alloc", response?.data);
      if (response && response.status === 200) {
        const data = response.data?.data || {};
        this.allocations = data.results || [];
        this.pagination.totalCount = data.totalCount || 0;
        this.pagination.pageIndex = data.pageIndex || this.pagination.pageIndex;
      } else {
        this.$message.error(
          response?.data?.message || "Failed to fetch allocation requests."
        );
        this.allocations = [];
        this.pagination.totalCount = 0;
      }
      this.loadingAllocations = false;
    },
    handleTableChange(pagination) {
      if (pagination.current !== this.pagination.pageIndex || pagination.pageSize !== this.pagination.pageSize) {
        this.pagination.pageIndex = pagination.current;
        this.pagination.pageSize = pagination.pageSize;
        this.fetchAllocations();
      }
    },
    calculateAverageFulfillmentTime(allocations) {
      const fulfilled = allocations.filter(
        (a) => a.status === "approved" && a.fulfillmentTime
      );
      if (!fulfilled.length) return 0;
      const totalDays = fulfilled.reduce(
        (sum, a) => sum + a.fulfillmentTime,
        0
      );
      return (totalDays / fulfilled.length).toFixed(1);
    },
    renderStatusTag(status) {
      let color,
        text = status;
      switch (status?.toLowerCase()) {
        case "pending":
          color = "orange";
          break;
        case "approved":
          color = "green";
          break;
        case "rejected":
          color = "red";
          break;
        case "expired":
          color = "red";
          break;
        case "active":
          color = "green";
          break;
        case "near expiry":
          color = "gold";
          break;
        case "delivered":
          color = "green";
          text = "Received";
          break;
        case "healthy":
          color = "green";
          break;
        default:
          color = "default";
      }
      return <a-tag color={color}>{text}</a-tag>;
    },
    handleAllocationView(record) {
      if (record.id) {
        this.$router.push({
          name: "AllocationDetails",
          params: { userId: this.sellerId, allocationId: record.id },
        });
      }
    },
  },
  created() {
    this.fetchAllocations();
  },
};
</script>

<style scoped>
.stats-row {
  margin-bottom: 24px;
}
.stat-card {
  border-radius: 8px;
}
.stat-label {
  font-weight: 600;
  font-size: 14px;
}
.stat-value {
  font-size: 18px;
  font-weight: 700;
  color: #26a246;
  margin-top: 8px;
}
.stat-suffix {
  font-size: 14px;
  color: #888;
}
.filter-row {
  margin-bottom: 16px;
}
.empty-state {
  text-align: center;
  padding: 48px 0;
}
.empty-icon {
  font-size: 28px;
  color: #26a246;
  margin-bottom: 16px;
}
.empty-title {
  font-size: 18px;
  color: #888;
}
.empty-desc {
  color: #aaa;
  margin-top: 8px;
}
.allocations-table {
  background: #fff;
  margin-top: 16px;
}
</style>
